import { Component, OnInit } from '@angular/core';
import {AppState, selectAuthState, selectPatientState} from '../../../store/app.states';
import {Store} from '@ngrx/store';
import {Observable} from 'rxjs';
import {Pending} from '../../../model/questionnaires/Pending';
import {Router} from '@angular/router';
import {GetPendings} from '../../../store/actions/patient.actions';
import * as _moment from 'moment';
import { Announcement } from 'src/app/model/announcement/Announcement';
import { PatientService } from 'src/app/services/patient.service';


@Component({
  selector: 'app-announcements-for-patients',
  templateUrl: './announcements-for-patients.component.html',
  styleUrls: ['./announcements-for-patients.component.css']
})
export class AnnouncementsForPatientsComponent implements OnInit {

  
    title = 'Avvisi';
    user = null;
    back = true;
    destination = '/landing';
    getAuthState: Observable<any>;
    getPatientState: Observable<any>;

    announcements : Announcement[];

  
    constructor(private store: Store<AppState>,
      private patientService: PatientService,
                private router: Router) {
      this.getAuthState = this.store.select(selectAuthState);
      this.getPatientState = this.store.select(selectPatientState);
  
  }
  
    ngOnInit(): void {
      this.getAuthState.subscribe((state) => {
        if (state.isAuthenticated) {
          this.user = JSON.parse(localStorage.getItem('user'));
          this.getAnnouncements();
        }
      });
    }

    getAnnouncements() {
      this.patientService.getAnnouncements().subscribe(received => {
        this.announcements=received;
        console.log(this.announcements);
        this.announcements.forEach(function(announcement){
          announcement.giorno = (new Date(announcement.date).getDate());
          announcement.mese = (new Date(announcement.date).getMonth()+1);
          announcement.anno = (new Date(announcement.date).getFullYear());
        } );
      }, error => {
        if (error.status === 500) {
          // nel caso di errore 500 vuol dire che è scaduto il token ma noi non ci siamo accorti
          localStorage.setItem('expirationTime', '0');
          console.log('sessione scaduta');
          location.reload();
        }
        // this.openErrorDialog('Il messaggio non è stato mandato per un errore. Se il problema persiste ci contatti via e-mail');
      });
    }

  }
  
  